import { RiComputerLine } from "react-icons/ri";
import { TbSettingsCode } from "react-icons/tb";

const TaskEngineIcon = (props) => {
    return (
        <div className={`computer-icon-${props?.size || 'md'}`}>
            <RiComputerLine className="computer-base" />
            <TbSettingsCode className={`computer-overlay-${props?.size || 'md'}`} />
        </div>
    );
};

export default TaskEngineIcon;